import { useNavigate, useSearchParams } from "@solidjs/router"
import { FaSolidRightFromBracket } from "solid-icons/fa"
import toast from "solid-toast"
import clearSessionToken from "../rx/shared/session/clearSessionToken"
import { createAlertBagStore, setAlertBagError } from '../rx/store/AlertBag'
import AlertBag from './AlertBag'
import createDefaultWait from "../lib/createDefaultWait"

type SignOutPageSearchParams = Record<'return_to', string>

const SignOutButton = () => {
  const ab = createAlertBagStore()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams<SignOutPageSearchParams>()

  // the user signs out using another tab,
  // then redirect them to the page they were on
  let navigating = false
  function navigateToIntended() {
    const { return_to } = searchParams
    if (navigating && return_to) {
      return
    }
    navigating = true
    // console.info('navigating')
    navigate(return_to || '/')
  }

  const handleClick = () => {
    console.log('SignOutButton.handleClick')
    try {
      setAlertBagError(ab, null)
      // await supabase.auth.signOut()
      // await clearAuthTokens()
      clearSessionToken()
      toast.success('Successsfully signed out')

      createDefaultWait(1000).then(navigateToIntended)
      // TODO goto home page '/'
    } catch (error) {
      console.error('Error signing out:', error)
      setAlertBagError(ab, error as Error)
    }
  }

  return (
    <button class="btn btn-danger btn-sm" onClick={handleClick}>
      Sign Out <FaSolidRightFromBracket />
      <AlertBag store={ab} />
    </button>
  )
}

export default SignOutButton